import React, { useEffect, useState } from "react";
import { corefetch, ImageURL } from "../../../Util/axios_core_helper";
import { useParams, Link } from "react-router-dom";
import { KendoLoader } from "../../../Kendo/kendo_loader";

export const GalleryPage = () => {
  const { galleryid } = useParams();
  const { Cat } = useParams();
  const [ballroomId, setBallroomId] = useState(null);
  const [loading, setLoading] = useState(true);
  const [galleryDetails, setGalleryDetails] = useState([]);
  const [error, setError] = useState("");

  const [BreadcrumList, setBreadcrumList] = useState([]);

  const fetchBreadcrumImageData = async () => {
    try {
      const response = await corefetch(
        `Breadcrum/GetBreadcrumDetailsByCategory?CategoryCode=GALLERY`
      );
      if (response && response.length > 0) {
        console.log("fxftyxfyt:", response);
        setBreadcrumList(response);
      } else {
        setBreadcrumList([]);
        console.log("No Breadcrum found");
      }
    } catch (error) {
      console.error("Error fetching Breadcrum List:", error);
      setBreadcrumList([]);
    }
  };

  useEffect(() => {
    fetchBreadcrumImageData();
  }, []);

  useEffect(() => {
    const fetchBallroomId = async () => {
      try {
        // let result;
        // if (Cat == "BallRoom") {
        //   result = await corefetch(
        //     `Facility/GetDisplayedinIDbyFailityID?facilityId=${galleryid}`
        //   );
        // }
        setBallroomId(galleryid);
      } catch (error) {
        console.error("Error fetching Ballroom ID:", error);
        setError("Unable to fetch gallery details. Please try again later.");
      } finally {
        setLoading(false);
      }
    };

    fetchBallroomId();
  }, [galleryid]);

  useEffect(() => {
    const fetchData = async () => {
      if (!ballroomId) return;

      try {
        const list = await corefetch(
          `Gallery/GetGalleyDetails?id=${ballroomId}&category=${Cat}`
        );
        setGalleryDetails(list?.length > 0 ? list : []);
      } catch (error) {
        console.error("Error fetching list:", error);
        setGalleryDetails([]);
        setError("Failed to load gallery details.");
      }
    };

    fetchData();
  }, [ballroomId]);

  if (loading) {
    return (
      <div>
        <KendoLoader />
      </div>
    );
  }

  if (!ballroomId) {
    return null;
  }

  const backgroundImageStyle = BreadcrumList[0]
    ? {
        backgroundImage: `url(${ImageURL}${BreadcrumList[0].imagePath})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }
    : {};
  return (
    <>
      <section className="wpo-page-title" style={backgroundImageStyle}>
        <div className="container">
          <div className="row">
            <div className="col col-xs-12">
              <div className="wpo-breadcumb-wrap">
                <h2>Gallery</h2>
                <ol className="wpo-breadcumb-wrap">
                  <li>
                    <a href="/home"> Home</a>
                  </li>
                  <li>Gallery</li>
                </ol>
              </div>
            </div>
          </div>
        </div>
      </section>
      <section className="wpo-portfolio-section-s4 pt-120 pb-0 section-padding">
        <div className="container">
          <div className="wpo-section-title">
            <h2>{galleryDetails[0]?.eventType || "Not Available"}</h2>
          </div>

          {error && <p className="error-message">{error}</p>}
          <div
            className="sortable-gallery"
            style={{ display: "flex", flexWrap: "wrap", gap: "10px" }}
          >
            <div className="row" style={{ width: "100%" }}>
              <div className="col-lg-12" style={{ width: "100%" }}>
                <div
                  className="portfolio-grids gallery-container clearfix"
                  style={{
                    display: "flex",
                    flexWrap: "wrap",
                    justifyContent: "center",
                  }}
                >
                  {galleryDetails.map((item, index) => (
                    <div
                      className="grid"
                      key={index}
                      style={{
                        borderRadius: "10px",
                        position: "relative",
                        overflow: "hidden",
                      }}
                    >
                      <div
                        className="img-holder"
                        style={{
                          position: "relative",
                          overflow: "hidden",
                          width: "100%",
                        }}
                      >
                        <a
                          href={`/gallerydetails/${item.eventTitle}/${item.galleryID}`}
                          style={{ textDecoration: "none" }}
                        >
                          <img
                            src={`${ImageURL}${item.imagePath}`}
                            alt={item.eventTitle}
                            className="gallery-image"
                            style={{
                              width: "100%",
                              height: "300px",
                              objectFit: "cover",
                              borderRadius: "15px",
                            }}
                          />
                          <div
                            className="portfolio-content"
                            style={{ textAlign: "center", padding: "10px" }}
                          >
                            <h4 style={{ textAlign: "center" }}>
                              {item.eventTitle}
                            </h4>
                            <span>
                              {Cat == "BallRoom"
                                ? item.category
                                : item.category}
                            </span>
                            <br />
                            <span>
                              {new Date(item.eventDate)
                                .toLocaleDateString("en-US", {
                                  month: "short",
                                  year: "numeric",
                                })
                                .toUpperCase()}
                            </span>
                          </div>
                        </a>
                      </div>
                    </div>
                  ))}
                  {galleryDetails.length === 0 && (
                    <p style={{ textAlign: "center", width: "100%" }}>
                      No gallery available at the moment.
                    </p>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};
